import angular from 'angular'

import envRaw from './env-raw'
import { get, has, unset } from 'lodash-es'

angular
  .module('ggs.utils')
  .factory('TryUseBootstrap', TryUseBootstrapProvider)

function TryUseBootstrapProvider($log, $q, qh) {
  return function TryUseBootstrap(path, action) {
    return function tryUseBootstrap_wrapper() {
      if (envRaw.useBootstrap) {
        if (has(envRaw.bootstrapOverride, path)) {
          $log.debug(`tryUseBootstrap: found [path=${path}] in envRaw.bootstrapOverride!`)
          const data = get(envRaw.bootstrapOverride, path)
          unset(envRaw.bootstrapOverride, path)
          unset(window, path)
          return $q.resolve(data)
        } else if (has(window, path)) {
          $log.debug(`tryUseBootstrap: found [path=${path}] in window!`)
          const data = get(window, path)
          unset(window, path)
          return $q.resolve(data)
        }
      }

      return qh.try(action, arguments)
    }
  }
}
